/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolleZentrale { 
    funktionsbereich_id: string;
    rolle_id: string;
    ist_aktiv?: boolean;
    ist_manager?: boolean;
    ist_abarbeiter?: boolean;
    ist_leser?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

